/**
 * @flow
 */

import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="24"
        viewBox="0 0 13 24"
      >
        <path
          fill="#DADADA"
          fillRule="nonzero"
          d="M1.527 23.651a.829.829 0 0 1-.598.246.829.829 0 0 1-.599-.246.838.838 0 0 1 0-1.19L10.854 12 .33 1.538a.838.838 0 0 1 0-1.19.85.85 0 0 1 1.197 0l11.122 11.057c.33.328.33.862 0 1.19L1.527 23.65z"
        />
      </svg>
    )
  }
}

export default IcRightArrow



// WEBPACK FOOTER //
// ./src/components/Icons/FranchisePageIcons/IcRightArrow/SvgFile.js